import moment from 'moment'

export function getNowTimeFullYear () {
  return moment().format('YYYY-MM-DD HH:mm:ss')
}



// WEBPACK FOOTER //
// ./src/util/nowTime.js